import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import ScoreWrapper from '../shared/wrapper';
import useSportsStore from '../../../hooks/useSportsStore';
import useScoreViewType from '../../../hooks/useScoreViewType';
import { timeUtils } from '../../../common/utils/timeUtil';
import Seo from '../../../components/seo';
import useStore from '../../../hooks/useStore';
import { _SPORTS_TYPE } from '../../../common/constants/sportsConstants';
// import AppLink from '../../../components/appLink';

const Major = observer(({ fromHome }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const date = query.get('date');

  const store = useSportsStore('major');
  const { viewType } = useScoreViewType();
  const { bannerStore } = useStore();
  // const [viewAppLink, setViewAppLink] = useState(false);

  useEffect(() => {
    bannerStore.setSportType(_SPORTS_TYPE.MAJOR);
    store.getFavoriteGames();
    return () => {
      store.closeSocket();
    };
  }, []);

  useEffect(() => {
    if (date?.length > 0) {
      store.getMajor(date);
    } else {
      store.getMajor(timeUtils.todayYmd());
    }
  }, [date]);

  // useEffect(() => {
  //   if (!window.sessionStorage.getItem('homeHideAppLink')) {
  //     setViewAppLink(true);
  //   }
  // }, []);

  return (
    <>
      <Seo title={'스포츠 주요경기'} />
      {/*{viewAppLink && (*/}
      {/*  <AppLink*/}
      {/*    onClickClose={() => {*/}
      {/*      setViewAppLink(false);*/}
      {/*      window.sessionStorage.setItem('homeHideAppLink', true);*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}
      <div className={clsx('game_list', (viewType === 'VERTICAL_VIEW' || fromHome) && 'vertical_view')}>
        <ScoreWrapper
          loading={store.loading}
          list={fromHome ? store.filteredMajorList : store.majorList}
          selectedGames={store.selectedGames}
          setSelectedGame={store.setSelectedGame}
          fromHome={fromHome}
        />
      </div>
    </>
  );
});

export default Major;
